'use client'

import cn from 'clsx'
import { useRect } from 'hamo'
import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { Link } from '../link'
import s from './button.module.css'
import { DotsGridCanvas, type DotsGridCanvasRef } from './dots-grid'

interface ButtonProps {
  children: React.ReactNode
  className?: string
  href?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export function Button({ children, className, href, ...props }: ButtonProps) {
  const gridRef = useRef<DotsGridCanvasRef | null>(null)
  const [rectRef, rect] = useRect()
  const pathname = usePathname()
  const activeStateRef = useRef(false)

  useEffect(() => {
    if (href === pathname) {
      gridRef.current?.enter()
      gridRef.current?.active()
      activeStateRef.current = true
    } else if (activeStateRef.current) {
      gridRef.current?.inactive()
      gridRef.current?.exit()
      activeStateRef.current = false
    }
  }, [href, pathname])

  return (
    <Link
      className={cn('w-full dr-h-44', s['dot-grid'], className)}
      onMouseOver={() => {
        gridRef.current?.enter()
      }}
      onMouseLeave={() => {
        gridRef.current?.exit?.()
      }}
      ref={rectRef}
      href={href}
      {...props}
    >
      <DotsGridCanvas
        rect={rect}
        className="w-full dr-h-44 pointer-events-none"
        ref={(instance) => {
          gridRef.current = instance
        }}
        speed={4}
      />
      <span className="relative text-[var(--color-offWhite)] cta lowercase text-center my-auto">
        {children}
      </span>
    </Link>
  )
}
